export const AUTOPILOT_EMOJI = "❇️";
